import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import config from '../../config';



import { PaperAirplaneIcon, XMarkIcon } from '@heroicons/react/20/solid';
import { Badge } from '../../catalyst/badge';
import { Button } from '../../catalyst/button';
import { Field, Label } from '../../catalyst/fieldset';
import { Listbox, ListboxLabel, ListboxOption } from '../../catalyst/listbox';
import LoadingMain from '../../components/LoadingMain';
import PremiumPopupForTransfer from '../premium/premiumPopupForTransfer'; 
import { getIconForTransfer } from './../../utils';


export default function SelectTargetAccount(props) {

    const [targetAccount, setTargetAccount] = useState('')
    const [showTransferError, setShowTrasnsferError] = useState(false)
    const [isTransferLoading, setTransferLoading] = useState('')
    const [triedTracksCount, setTriedTracksCount] = useState(0)
    const [showPremiumOptions, setShowPremiumOptions] = useState(false)


    const navigate = useNavigate();

    const handleCurrentAccountSelectionChange = (id) => {
        setTargetAccount(id);
        isYoutubeSelected()
    };

    function isYoutubeSelected() {
        if(targetAccount === '') {
            return false;
        }
        for (let i = 0; i < props.connectedAccounts.length; i++) {
            if(props.connectedAccounts[i].id === targetAccount && props.connectedAccounts[i].accountType === "youtube") {
                return true
            }
        }
        return false;
    }
    
    function isAlbumSelected() {

        for (let i = 0; i < props.transferData.length; i++) {
            if(props.transferData[i].sourcePlaylistType === "album") {
                return true
            }
        }
        return false;
    }
    
    function SelectedItems() {
        var playlistCount = 0;
        var albumCount = 0;
        var likedSongsCount = 0;
        for (const transfer of props.transferData) {
            if(transfer.sourcePlaylistType === "playlist") {
                playlistCount++;
            }
            if(transfer.sourcePlaylistType === "liked") {
                likedSongsCount++;
            }
            if(transfer.sourcePlaylistType === "album") {
                albumCount = transfer.sourcePlaylistId.split(',').length
            }
          }
        return(
            <>
                  <Badge color="lime" className="m-5">Transferring {likedSongsCount>0?" all liked songs,":""} {playlistCount} playlist(s) and {albumCount} album(s)</Badge>
            </>
        )
    }

    function TargetAccountSelector() {
        return (
            <>

                <Field>
                <Label>Select Target Account</Label>
                <Listbox 
                onChange={(id) => handleCurrentAccountSelectionChange(id)}
                value={targetAccount === '' ? undefined : targetAccount}
                placeholder="Select the destination account"
                className="cursor-pointer"
                >
                    {/* {users.map((user) => (
                    <ListboxOption key={user.id} value={user}>
                        <Avatar src={user.avatarUrl} initials={user.initials} className="bg-purple-500 text-white" alt="" />
                        <ListboxLabel>{user.name}</ListboxLabel>
                    </ListboxOption>
                    ))} */}


                    {
                            props.connectedAccounts.map((account) => {
                                if (account.accountType === "spotify") {
                                    if (account.id === props.sourceAccountId) {
                                        return
                                    }
                                    return (<ListboxOption className="cursor-pointer" value={account.id} key={account.id}>{getIconForTransfer(account.accountType)} &nbsp; <ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }

                        {/* <MenuItem value="">
                            <em>Spotify</em>
                        </MenuItem> */}
                        {
                            props.connectedAccounts.map((account) => {
                                if (account.accountType === "appleMusic") {
                                    if (account.id === props.sourceAccountId) {
                                        return
                                    }
                                    return (<ListboxOption className="cursor-pointer" value={account.id} key={account.id}>{getIconForTransfer(account.accountType)}&nbsp;<ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }
                        
                        {
                            props.connectedAccounts.map((account) => {
                                if (account.accountType === "youtube") {
                                    if (account.id === props.sourceAccountId) {
                                        return
                                    }
                                    return (<ListboxOption className="cursor-pointer" value={account.id} key={account.id}>{getIconForTransfer(account.accountType, account.isYoutubeMusic)}&nbsp;<ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }


                        {
                            props.connectedAccounts.map((account) => {
                                if (account.accountType === "tidal") {
                                    if (account.id === props.sourceAccountId) {
                                        return
                                    }
                                    return (<ListboxOption className="cursor-pointer" value={account.id} key={account.id}>{getIconForTransfer(account.accountType)} &nbsp; <ListboxLabel>{account.profileName}</ListboxLabel></ListboxOption>)
                                }
                            })
                        }
                </Listbox>
                </Field>






            </>
        );
    }


    function cancelTransfer() {
        props.setShowTransferTargetMenu(false)
    }

    function startTransfer() {

        setShowTrasnsferError(false)
        setTransferLoading(true)
        let transferData = props.transferData;
        transferData = transferData.map(transfer => ({
            ...transfer,
            "destinationCaId": targetAccount
        }))


        fetch(config.apiUrl + "/transfer", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('user')).accessToken,
            },
            body: JSON.stringify(transferData),
        }).then(response => {
            if (!response.ok) {
                throw new Error('Failed to create transfer job');
            }
            return response.json();
        })
            .then(jsonData => {
                if(jsonData.noOfTransfersRequested != null) {
                    setTransferLoading(false)
                    setTriedTracksCount(jsonData.noOfTransfersRequested)
                    setShowPremiumOptions(true)
                    return
                }
                setTransferLoading(false)
                setShowTrasnsferError(false)
                navigate('/dashboard/transferHistory?message=TRANSFER_STARTED')
            })
            .catch(error => {
                setTransferLoading(false)
                setShowTrasnsferError(true)
            });

    }


    return (
        <>
            {isTransferLoading ? <><LoadingMain /></>

                :
                 <>          
                    <PremiumPopupForTransfer showPremiumOptions={showPremiumOptions} setShowPremiumOptions={(flag) => setShowPremiumOptions(flag)} triedTracksCount={triedTracksCount}></PremiumPopupForTransfer>      
                    <TargetAccountSelector></TargetAccountSelector>
                    <>{SelectedItems()}</>
                    {showTransferError ? <><Badge color="rose">Failed to start transfer. Please try again or later.</Badge></> : <></>}

                    {isYoutubeSelected() && isAlbumSelected()? <><Badge color="rose">Album transfer not supported for youtube.</Badge></> : <></>}

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <Button onClick={() => cancelTransfer()} outline>
                            <XMarkIcon></XMarkIcon>
                            Cancel
                        </Button>
                        <Button variant="contained" onClick={() => startTransfer()} disabled={targetAccount === ''}>
                            {props.transferData[0].transferMethod === "automatic" ? "Transfer" : "Load Songs"}
                            <PaperAirplaneIcon></PaperAirplaneIcon>
                        </Button>
                    </div>
                </>}


            <></>

        </>
    )
}